import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { depositKeys } from '@/lib/queryKeys';
import { depositEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';
import type { Deposit, ForfeitDepositInput } from '@/types/deposit';

interface ForfeitArgs extends ForfeitDepositInput {
  depositId: string;
}

/** Spec §9.3.2 — admin-only forfeit; QBO journal-entry to Forfeited Income. */
export function useForfeitDeposit() {
  const queryClient = useQueryClient();

  return useApiMutation<Deposit, ForfeitArgs>({
    mutationFn: ({ depositId, ...body }) =>
      apiPost<Deposit, ForfeitDepositInput>(
        operationsClient,
        depositEndpoints.forfeit(depositId),
        body,
      ),
    onSuccess: (deposit) => {
      queryClient.setQueryData(depositKeys.detail(deposit.id), deposit);
      void queryClient.invalidateQueries({ queryKey: depositKeys.all() });
      toast.success('Deposit forfeited');
    },
  });
}
